/* CHAOS Coat Edit: genuine photos, available variants, accurate indicative savings. */
(function(){
'use strict';
if(window.__chaosStylistV2)return;
window.__chaosStylistV2=true;
var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
root=root.replace(/\/?$/,'/');
var feed=null;
function money(p){return 'Rs '+Math.round((Number(p)||0)/100).toLocaleString('en-PK');}
function catalog(){
 if(feed)return feed;
 var n=document.getElementById('chaos-coat-curated-data');if(!n)return null;
 try{feed=JSON.parse(n.textContent);return feed;}catch(e){return null;}
}
function coats(cart){
 var out=[];
 if(!cart||!Array.isArray(cart.items))return out;
 cart.items.forEach(function(item){
  if(!item||String(item.handle||'')==='coat-cover'||String(item.product_title||item.title||'').toLowerCase().indexOf('coat')<0)return;
  var q=Math.max(0,Number(item.quantity)||0),p=Number(item.original_price);
  if(!isFinite(p)||p<0)p=Number(item.price)||0;
  for(var i=0;i<Math.min(q,80);i++)out.push({id:String(item.product_id||''),handle:String(item.handle||''),title:String(item.product_title||item.title||''),price:p});
 });
 return out;
}
function estimate(arr){
 var a=arr.map(function(x){return Number(x.price)||0;}).sort(function(x,y){return y-x;});
 if(a.length===2)return Math.round(a[1]*.20);
 if(a.length>=3)return Math.round((a[a.length-1]+a[a.length-2])*.30);
 return 0;
}
function family(t){
 t=String(t||'').toLowerCase();
 if(/black|grey|gray|charcoal|raven|after.dark/.test(t))return'dark';
 if(/beige|ivory|cream|latte|camel|nude|sandstone|bone|white/.test(t))return'neutral';
 if(/brown|chocolate|chocolat|tan|saddle|peru/.test(t))return'warm';
 return'statement';
}
function eligible(p){return p&&p.available&&p.image&&p.variants&&p.variants.some(function(v){return v.available;});}
function gender(base,db){
 if(!base)return'women';
 if(db.men.some(function(p){return String(p.id)===String(base.id);}))return'men';
 if(db.women.some(function(p){return String(p.id)===String(base.id);}))return'women';
 return /\bmen\b|\bmens\b|\bgents\b/.test(String(base.title).toLowerCase())?'men':'women';
}
function picks(base,cart,db){
 var inCart=Object.create(null);coats(cart).forEach(function(x){inCart[x.id]=true;});
 if(base&&base.id)inCart[String(base.id)]=true;
 var available=(db[gender(base,db)]||[]).filter(function(x){return eligible(x)&&!inCart[String(x.id)];});
 var palette=family(base&&base.title);
 var targets=palette==='neutral'?['statement','dark','warm']:palette==='dark'?['neutral','statement','warm']:palette==='warm'?['dark','neutral','statement']:['neutral','dark','warm'];
 var selected=[],seen=Object.create(null);
 targets.forEach(function(t){var x=available.find(function(p){return family(p.title)===t&&!seen[String(p.id)];});if(x){seen[String(x.id)]=true;selected.push(x);}});
 available.forEach(function(x){if(selected.length<3&&!seen[String(x.id)]){selected.push(x);seen[String(x.id)]=true;}});
 return selected.slice(0,3);
}
function el(tag,cls,text){var x=document.createElement(tag);if(cls)x.className=cls;if(text!=null)x.textContent=text;return x;}
function renderPrice(card,v,cart,context,base){
 var note=card.querySelector('[data-chaos-card-value]');if(!note)return;
 var price=v?Number(v.price)||0:0;
 if(!price){note.textContent='Choose your size';return;}
 if(context==='cart'){
  var before=coats(cart),after=before.concat([{price:price}]);
  var extra=Math.max(0,price-estimate(after)+estimate(before));
  note.textContent=before.length===1||before.length===2?'Approx. '+money(extra)+' more after savings':'Add this look for '+money(price);
 }else{
  var basePrice=Number(base&&base.price)||0;
  var saving=estimate([{price:basePrice},{price:price}]);
  note.textContent=saving?'Potential pairing saving: '+money(saving):'Pair it with your favourite';
 }
}
function renderCard(p,context,cart,base,label){
 var card=el('article','chaos-curated__card');
 var photo=el('a','chaos-curated__photo');photo.href=p.url;
 var image=el('img');image.src=p.image;image.alt=p.title;image.loading='lazy';image.decoding='async';photo.appendChild(image);card.appendChild(photo);
 var body=el('div','chaos-curated__details');card.appendChild(body);
 body.appendChild(el('span','chaos-curated__label',label));
 var link=el('a','chaos-curated__title',p.title);link.href=p.url;body.appendChild(link);
 var variants=p.variants.filter(function(v){return v.available;});
 var current=variants[0]||null;
 var price=el('span','chaos-curated__price',current?money(current.price):'');body.appendChild(price);
 var value=el('span','chaos-curated__value');value.setAttribute('data-chaos-card-value','');body.appendChild(value);
 var select=el('select','chaos-curated__select');select.setAttribute('aria-label','Choose available size for '+p.title);
 var placeholder=el('option','', 'Choose size');placeholder.value='';select.appendChild(placeholder);
 variants.forEach(function(v){var op=el('option','',v.title==='Default Title'?'One size':v.title);op.value=String(v.id);select.appendChild(op);});
 var chosen=null;if(variants.length===1){select.value=String(current.id);chosen=current;select.hidden=true;}
 body.appendChild(select);
 var button=el('button','chaos-curated__add','ADD THIS COAT');button.type='button';button.disabled=!chosen;body.appendChild(button);
 var error=el('span','chaos-curated__error');error.setAttribute('role','status');body.appendChild(error);
 renderPrice(card,chosen||current,cart,context,base);
 select.addEventListener('change',function(){
  chosen=variants.find(function(v){return String(v.id)===select.value;})||null;
  button.disabled=!chosen;error.textContent='';price.textContent=money((chosen||current).price);renderPrice(card,chosen||current,cart,context,base);
 });
 button.addEventListener('click',function(){
  if(!chosen||button.disabled)return;
  button.disabled=true;button.textContent='ADDING…';error.textContent='';
  window.fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:Number(chosen.id),quantity:1})})
  .then(function(r){if(!r.ok)throw Error('Unavailable');return r.json();})
  .then(function(){
   try{window.sessionStorage.setItem('chaos_coat_reward_pending','1');}catch(e){}
   window.location.assign(root+'cart?coat_edit_added=1');
  }).catch(function(){button.disabled=false;button.textContent='ADD THIS COAT';error.textContent='Unable to add this size. Please try again.';});
 });
 return card;
}
function findBase(id,db){
 var found=null;['women','men'].forEach(function(g){(db[g]||[]).forEach(function(p){if(String(p.id)===String(id))found=p;});});return found;
}
function render(node,cart,db){
 var context=node.getAttribute('data-chaos-context')||'cart',inCart=coats(cart);
 if(context==='cart'&&(inCart.length===0||inCart.length>=3)){node.hidden=true;return;}
 var base=context==='cart'?inCart[0]:findBase(node.getAttribute('data-chaos-product-id'),db);
 if(!base&&context==='product')base={id:node.getAttribute('data-chaos-product-id'),title:node.getAttribute('data-chaos-product-title')||'',price:Number(node.getAttribute('data-chaos-product-price'))||0};
 if(!base){node.hidden=true;return;}
 var ps=picks(base,cart,db);if(ps.length===0){node.hidden=true;return;}
 if(context==='cart'){
  var h=node.querySelector('.chaos-curated__heading h3'),sub=node.querySelector('.chaos-curated__heading p');
  if(h)h.textContent=inCart.length===1?'Choose your second coat':'One more coat, a bigger reward';
  if(sub)sub.textContent=inCart.length===1?'Choose a complementary coat and unlock 20% off the lower-priced one.':'Add one more for 30% off both of your two lower-priced coats.';
 }
 var holder=node.querySelector('[data-chaos-curated-cards]');if(!holder)return;
 while(holder.firstChild)holder.removeChild(holder.firstChild);
 ['The statement','The timeless edit','The alternative'].forEach(function(label,i){if(ps[i])holder.appendChild(renderCard(ps[i],context,cart,base,label));});
 node.hidden=false;
}
function showSavings(cart){
 var c=coats(cart),amount=estimate(c);
 document.querySelectorAll('[data-chaos-savings]').forEach(function(n){
  n.hidden=c.length<2;if(n.hidden)return;
  var x=n.querySelector('[data-chaos-savings-number]');if(x)x.textContent=money(amount);
  var p=n.querySelector('[data-chaos-savings-note]');
  if(p)p.textContent=c.length===2?'Estimated coat saving. Add a third coat to unlock 30% off both lower-priced coats.':'Estimated coat saving with 30% off each of the two lower-priced coats.';
 });
}
function paint(cart){var db=catalog();if(!db)return;showSavings(cart);document.querySelectorAll('[data-chaos-curated]').forEach(function(x){render(x,cart,db);});}
function init(){
 if(!catalog())return;
 document.addEventListener('chaos:cart:synced',function(e){if(e.detail&&e.detail.cart)paint(e.detail.cart);});
 window.fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}}).then(function(r){if(!r.ok)throw Error('Cart');return r.json();}).then(paint).catch(function(){});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
}());
